import { ButtonGroup } from '@mui/material';
import Button from '@mui/material/Button';
import { useHiroCtx } from '../../HiroProvider';
import { dayjs, isMarketOpenOnDate, ET } from 'util/shared/date';
import { SGTooltip } from 'components/core';

export const RecentDaysSelector = () => {
  const { update, includeHiroETH: showExtendedHours } = useHiroCtx();
  return (
    <ButtonGroup
      variant="outlined"
      aria-label="outlined secondary button group"
      sx={{
        alignSelf: 'center',
        height: '28px',
        minWidth: '3em',
        maxWidth: '2em',
        marginRight: '2ex',
      }}
    >
      <SGTooltip title="Display the last day" placement="top">
        <Button
          sx={{
            fontFamily: 'SF Pro Display',
            fontSize: 12,
            textTransform: 'capitalize',
            whiteSpace: 'nowrap',
            textAlign: 'center',
            minWidth: '1em!important',
          }}
          onClick={() => {
            let to = dayjs().tz(ET);
            if (
              !showExtendedHours &&
              (to.hour() < 9 || (to.hour() == 9 && to.minute() < 30))
            ) {
              to = to.subtract(1, 'day');
            }
            while (!isMarketOpenOnDate(to)) {
              to = to.subtract(1, 'day');
            }
            update({
              startQueryDate: to,
              endQueryDate: to,
              candleDuration: 5,
            });
          }}
        >
          1d
        </Button>
      </SGTooltip>
      <SGTooltip title="Display the last 5 days" placement="top">
        <Button
          sx={{
            fontFamily: 'SF Pro Display',
            fontSize: 12,
            textTransform: 'capitalize',
            whiteSpace: 'nowrap',
            textAlign: 'center',
            minWidth: '1em!important',
          }}
          onClick={() => {
            let to = dayjs().tz(ET);
            if (
              !showExtendedHours &&
              (to.hour() < 9 || (to.hour() == 9 && to.minute() < 30))
            ) {
              to = to.subtract(1, 'day');
            }
            while (!isMarketOpenOnDate(to)) {
              to = to.subtract(1, 'day');
            }
            let from = to;
            for (let i = 0; i < 5; ++i) {
              from = from.subtract(1, 'day');
              while (!isMarketOpenOnDate(from)) {
                from = from.subtract(1, 'day');
              }
            }
            update({
              startQueryDate: from,
              endQueryDate: to,
              candleDuration: 5 * 60,
            });
          }}
        >
          5d
        </Button>
      </SGTooltip>
    </ButtonGroup>
  );
};
